/**
 * Spread onto the free-text config inputs in the portal settings editor to stop password managers
 * from autofilling them.
 *
 * LastPass and 1Password both ignore `autoComplete="off"`, so the vendor opt-out attributes are the
 * only reliable lever. Pair this with an `id`/`name` that contains "search" and none of the
 * credential tokens LastPass keys off ("login", "email", "user", "password") — a settings field
 * called `loginDescription` is otherwise classified as a username box and filled with the admin's
 * own email, which then gets saved into the tenant's portal config.
 */
export const passwordManagerIgnoreProps = {
  autoComplete: "off",
  "data-lpignore": "true",
  "data-1p-ignore": "true",
};
